export default __webpack_public_path__ + "static/media/np_congratulations.3dc0d95f.svg";